import "./zoom-gallery";

class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.activeVideos = [];

    this.handleResize = () => this._checkCarousel();

    window.loadSwiper.then(({ Swiper, Pagination }) => {
      this.Swiper = Swiper;
      this.Pagination = Pagination;

      window.addEventListener("resize", this.handleResize);
      this._checkCarousel();

      this.addEventListener("click", (e) => {
        if (this._isMobile) return;

        const zoomGallery = this._zoomMarkup.content.children[0];
        const mediaButton = e.target.closest("[data-media-index]");
        zoomGallery.dataset.preselectMediaIndex =
          mediaButton?.dataset.mediaIndex || 0;

        const html = zoomGallery.outerHTML;
        (mediaButton || this).dispatchEvent(
          new CustomEvent("markup-modal:open", {
            bubbles: true,
            detail: { html, target: "zoom-modal" },
          }),
        );
      });
    });
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
  }

  _checkCarousel() {
    if (this._isMobile) {
      this._initCarousel();
    } else {
      this._destroyCarousel();
    }
  }

  _initCarousel() {
    if (this.gallerySwiper) return;

    console.log("INIT GALLERY CAROUSEL");

    this._toggleSwiperClasses(true);

    const swiperParams = {
      modules: [this.Pagination],
      slidesPerView: "auto",
      spaceBetween: 2,
      speed: 400,
      zoom: {
        maxRatio: 3,
      },
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    };

    this.gallerySwiper = new this.Swiper(
      this.querySelector(`.${this._prefix}__media-container`),
      swiperParams,
    );

    this.gallerySwiper.on("slideChange", (e) => {
      const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
        slide.classList.contains("swiper-slide-visible"),
      );
      this._selectVideo(visibleSlides);
    });
  }

  _destroyCarousel() {
    if (this.gallerySwiper) {
      this.gallerySwiper.destroy(true, true);
      this.gallerySwiper = null;
    }
    this._toggleSwiperClasses(false);
  }

  _toggleSwiperClasses(add) {
    this.querySelectorAll("[data-swiper-class]").forEach((el) => {
      el.classList.toggle(el.dataset.swiperClass, add);
    });
  }

  _selectVideo(els) {
    this.activeVideos.forEach((video) => video.pause());

    this.activeVideos = [];

    els.forEach((el) => {
      const video = el.querySelector("video");

      if (video) {
        this.activeVideos.push(video);
        video.play();
      }
    });
  }

  get _zoomMarkup() {
    return this.querySelector("[data-zoom-markup]");
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 666px)").matches;
  }
}

if (!customElements.get("media-gallery")) {
  customElements.define("media-gallery", MediaGallery);
}
